module.exports = "/_next/static/images/1dae749466184c4f4ed663a44dc044d5-complexity@md-1x.jpg.webp";